import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { ValidationError } from '../types';

interface ValidationErrorsProps {
  errors: ValidationError[];
}

export function ValidationErrors({ errors }: ValidationErrorsProps) {
  const { t } = useTranslation('customer-onboarding');

  if (errors.length === 0) return null;

  return (
    <div className="rounded-lg border border-destructive/50 bg-destructive/5 p-4">
      <div className="mb-4 flex items-center gap-2">
        <AlertTriangle className="h-5 w-5 text-destructive" />
        <h3 className="font-semibold text-destructive">
          {t('validation.title', { count: errors.length })}
        </h3>
      </div>

      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[120px]">{t('validation.columns.entity')}</TableHead>
              <TableHead className="w-[80px]">{t('validation.columns.row')}</TableHead>
              <TableHead className="w-[120px]">{t('validation.columns.column')}</TableHead>
              <TableHead>{t('validation.columns.error')}</TableHead>
              <TableHead className="w-[150px]">{t('validation.columns.value')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {errors.map((error, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium capitalize">
                  {error.entity}
                </TableCell>
                <TableCell>{error.row}</TableCell>
                <TableCell>{error.column}</TableCell>
                <TableCell className="text-destructive">
                  {t(`validation.errorMessages.${error.error}`, {
                    defaultValue: error.message || error.error,
                  })}
                </TableCell>
                <TableCell className="font-mono text-sm text-muted-foreground">
                  {error.value || '-'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
